import React from 'react';
import './Pagination.css';
import { useDispatch, useSelector } from 'react-redux';
// import { setRowsPerPage } from '../../store/modules/FaqStore';
// import { setRowsPerPage } from '../../store/modules/RequestStore';
import { setRowsPerPage as setRowsPerPageRequest } from '../../store/modules/RequestStore';
import { setRowsPerPage as setRowsPerPageFaq } from '../../store/modules/FaqStore';
import { RootState } from '../../store/store';

export interface Props {
  page: number;
  totalPages: number;
  handlePagination: (page: number) => void;
  rowsPerPage: number;
  storeType: 'request' | 'faq';
}

export const PaginationComponent: React.FC<Props> = ({
  page,
  totalPages,
  handlePagination,
  rowsPerPage,
  storeType,
}) => {
  const dispatch = useDispatch();

  let startItem = (page - 1) * rowsPerPage + 1;
  startItem = startItem > totalPages ? totalPages : startItem;
  let endItem = page * rowsPerPage;
  endItem = endItem > totalPages ? totalPages : endItem;

  const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    const currentFirstItemIndex = (page - 1) * rowsPerPage;
    // const currentFirstItemIndex = (page - 1) * rowsPerPage + 1;
    const newPage = Math.floor(currentFirstItemIndex / newRowsPerPage) + 1;

    if (storeType === 'request') {
      dispatch(setRowsPerPageRequest(newRowsPerPage));
    } else if (storeType === 'faq') {
      dispatch(setRowsPerPageFaq(newRowsPerPage));
    }
    // dispatch(setRowsPerPage(newRowsPerPage));
    handlePagination(newPage);
  };

  return (
    <div className="pagination-container">
      <div className="pagination-select">
        <select
          id="rowsPerPage"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
        </select>
      </div>
      <div>
        <span className="pagination-info">{startItem} - {endItem} de {totalPages}</span>
        <button
          onClick={() => handlePagination(Math.max(1, page - 1))}
          className={`pagination-button ${page === 1 ? "disabled" : ""}`}
          disabled={page === 1}
        >
          &lt;
        </button>
        <button
          onClick={() => handlePagination(Math.min(totalPages, page + 1))}
          className={`pagination-button ${(endItem === totalPages) ? "disabled" : ""}`}
          disabled={endItem === totalPages}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default PaginationComponent;
